import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { useDispatch } from "react-redux";
import { setUser, clearUser, setUserRole, setAuthReady } from "../../../redux/actions/authActions";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getUserRole } from "../../utils/getUserRole";

const AuthBootstrapper = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, async (user) => {
			if (user) {
				try {
					const docRef = doc(db, "usuarios", user.uid);
					const docSnap = await getDoc(docRef);

					if (docSnap.exists()) {
						const { nombre } = docSnap.data();
						dispatch(setUser(nombre || "Usuario"));
					} else {
						dispatch(setUser("Usuario"));
					}

					const rol = await getUserRole();
					dispatch(setUserRole(rol || "usuario"));

					// ⚡ Solo ahora que tenemos usuario y rol, decimos que está listo:
					dispatch(setAuthReady(true));
				} catch (error) {
					console.error("Error al restaurar usuario:", error);
					dispatch(clearUser());
					dispatch(setAuthReady(true)); // Incluso en error, debes marcar ready
				}
			} else {
				dispatch(clearUser());
				dispatch(setAuthReady(true));
			}
		});

		return () => unsubscribe();
	}, [dispatch]);

	return null;
};

export default AuthBootstrapper;
